<template>
  <v-card class="mr-3 ml-3 mb-3 pa-3">
    <v-card-title class="headline">Добавление Объекта</v-card-title>
    <v-card-text>
      <v-form v-model="isValid" ref="form">
        <v-row>
          <v-col cols="12" sm="6">
            <v-text-field label="Название"
                          v-model="object.name"
                          :rules="[notEmptyRule, length100]"
                          counter="100"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-autocomplete
                v-model="object.dealer"
                :items="choices.dealers"
                label="Дилер (кто будет обслуживать софт на объекте, а не дилер по коду ресторана)"
                no-data-text="Дилер не найден"
                :rules="[notEmptyRule]"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field label="Город"
                          v-model="object.city"
                          :rules="[notEmptyRule, length50]"
                          counter="50"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field label="Email"
                          v-model="object.email"
                          :rules="[notEmptyRule, emailRule, length50]"
                          counter="50"
                          hint="Для рассылки оповещений"
                          persistent-hint
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-textarea label="Доп. инфо"
                        :rows="3"
                        v-model="object.description"
                        :rules="[notEmptyRule]"
                        hint="Контактное лицо, телефон, удаленка и т.п."
                        persistent-hint
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary darken-1" text @click="createObject"
             :disabled="!isValid">Добавить
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import API from "@/axios/api";

export default {
  name: 'ObjectCreate',
  data() {
    return {
      object: {},
      choices: {
        dealers: [],
      },
      isValid: false,
      notEmptyRule: v => !!v || 'Поле не может быть пустым',
      emailRule: v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(v) || 'Неверный формат email',
      length100: v => (v && v.length <= 100) || 'Максимум 100 символов',
      length50: v => (v && v.length <= 50) || 'Максимум 50 символов',
    }
  },
  methods: {
    getDealerChoices() {
      API.get('dealers/choices')
          .then((response) => {
            console.log(response.data);
            this.choices.dealers = response.data.choices;
          })
          .catch((error) => {
            console.log(error);
          });
    },
    createObject() {
      API.post('objects/create', this.object)
          .then((response) => {
            console.log(response.data);
            this.$store.commit('showSnackbar', {
              color: 'success',
              text: 'Объект добавлен',
            })
            // this.$refs.form.reset();
            this.$store.dispatch('updateObjects');
            this.$router.push('/objects');
          })
          .catch((error) => {
            console.log(error);
            this.$store.commit('showSnackbar', {
              color: 'error',
              text: 'Объект не добавлен',
            })
          });
    },
  },
  created() {
    this.$store.commit('setCrumbs', [
      {text: 'main', disabled: false, to: '/', exact: true},
      {text: 'objects', disabled: false, to: '/objects', exact: true},
      {text: 'add', disabled: true},
    ])
    this.getDealerChoices();
  },
}
</script>